<template>
  <footer class="bg-[#070b12] text-white pt-16 pb-8 border-t border-white/10">
    <div class="container mx-auto px-4 lg:px-8">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-12 border-b border-white/10">
        <!-- Company Info -->
        <div>
          <router-link to="/" class="flex items-center gap-3 mb-6">
            <div class="w-12 h-12 bg-[var(--color-primary)] rounded-xl flex items-center justify-center">
              <span class="text-white font-bold text-2xl">X</span>
            </div>
            <div class="flex flex-col">
              <span class="text-2xl font-bold leading-tight">{{ $t('logoText') }}</span>
              <span class="text-sm font-semibold text-[var(--color-accent-bright)] tracking-wider">XIONGSU</span>
            </div>
          </router-link>
          <p class="text-gray-400 text-sm leading-relaxed">{{ $t('footerDescription') }}</p>
        </div>

        <!-- Products -->
        <div>
          <h4 class="text-lg font-semibold mb-6">{{ $t('footerProductsTitle') }}</h4>
          <ul class="space-y-3">
            <li v-for="p in footerProducts" :key="p.id">
              <router-link :to="'/products/' + p.id" class="text-gray-400 text-sm hover:text-white transition-colors">
                {{ $t(p.label) }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Quick Links -->
        <div>
          <h4 class="text-lg font-semibold mb-6">{{ $t('footerQuickLinksTitle') }}</h4>
          <ul class="space-y-3">
            <li v-for="link in quickLinks" :key="link.to">
              <router-link :to="link.to" class="text-gray-400 text-sm hover:text-white transition-colors">
                {{ $t(link.label) }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Contact -->
        <div>
          <h4 class="text-lg font-semibold mb-6">{{ $t('footerContactTitle') }}</h4>
          <ul class="space-y-4">
            <li class="flex items-start gap-3">
              <MapPin class="w-5 h-5 text-[var(--color-accent-bright)] mt-0.5 flex-shrink-0" />
              <span class="text-gray-400 text-sm">{{ $t('footerAddress') }}</span>
            </li>
            <li class="flex items-start gap-3">
              <Phone class="w-5 h-5 text-[var(--color-accent-bright)] mt-0.5 flex-shrink-0" />
              <span class="text-gray-400 text-sm">{{ $t('footerPhone') }}</span>
            </li>
            <li class="flex items-start gap-3">
              <BarChart2 class="w-5 h-5 text-[var(--color-accent-bright)] mt-0.5 flex-shrink-0" />
              <span class="text-gray-400 text-sm">{{ $t('footerStock') }}</span>
            </li>
          </ul>
        </div>
      </div>

      <!-- Bottom -->
      <div class="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
        <p class="text-gray-500 text-sm">{{ $t('footerCopyright') }}</p>
        <div class="flex items-center gap-6">
          <a href="#" class="text-gray-500 text-sm hover:text-white transition-colors">{{ $t('footerPrivacy') }}</a>
          <a href="#" class="text-gray-500 text-sm hover:text-white transition-colors">{{ $t('footerTerms') }}</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { MapPin, Phone, BarChart2 } from 'lucide-vue-next'

// footerProduct1..6 (en.json) map 1:1 in order to these real product ids.
const footerProducts = [
  { id: 'ppr_water', label: 'footerProduct1' },
  { id: 'pe_water', label: 'footerProduct2' },
  { id: 'pvc_u_water', label: 'footerProduct3' },
  { id: 'pvc_u_drainage', label: 'footerProduct4' },
  { id: 'pvc_conduit', label: 'footerProduct5' },
  { id: 'ppr_household', label: 'footerProduct6' }
]

const quickLinks = [
  { to: '/about', label: 'footerLink1' },
  { to: '/bases', label: 'footerLink2' },
  { to: '/quality', label: 'footerLink3' },
  { to: '/news', label: 'footerLink4' },
  { to: '/contact', label: 'footerLink5' }
]
</script>
